<script setup lang="ts">
// Step 4: calls & reports — animated waveform between a phone glyph and
// a small chart, evoking "every call is captured and measurable".
</script>

<template>
  <div class="relative h-full w-full flex items-center justify-center">
    <svg
      viewBox="0 0 320 220"
      class="h-full w-auto"
      role="img"
      aria-hidden="true"
    >
      <defs>
        <linearGradient id="wg-calls-bar" x1="0" y1="1" x2="0" y2="0">
          <stop offset="0%" stop-color="rgb(var(--accent))" stop-opacity="0.3" />
          <stop offset="100%" stop-color="rgb(var(--accent))" />
        </linearGradient>
      </defs>

      <!-- phone glyph -->
      <g transform="translate(40 76)">
        <rect width="68" height="68" rx="18" fill="rgb(var(--surface-elevated))" stroke="rgb(var(--border))" />
        <path
          d="M22 24 q-2 -6 4 -10 l6 6 l-4 8 q4 8 14 14 l8 -4 l6 6 q-4 6 -10 4 q-18 -4 -26 -24 z"
          fill="rgb(var(--accent))"
        />
      </g>

      <!-- waveform between -->
      <g stroke="rgb(var(--accent))" stroke-width="3" stroke-linecap="round">
        <line x1="120" y1="110" x2="120" y2="110">
          <animate attributeName="y1" values="100;120;100" dur="1s" repeatCount="indefinite" />
          <animate attributeName="y2" values="120;100;120" dur="1s" repeatCount="indefinite" />
        </line>
        <line x1="132" y1="110" x2="132" y2="110">
          <animate attributeName="y1" values="92;128;92" dur="1.1s" repeatCount="indefinite" />
          <animate attributeName="y2" values="128;92;128" dur="1.1s" repeatCount="indefinite" />
        </line>
        <line x1="144" y1="110" x2="144" y2="110">
          <animate attributeName="y1" values="82;138;82" dur="1.2s" repeatCount="indefinite" />
          <animate attributeName="y2" values="138;82;138" dur="1.2s" repeatCount="indefinite" />
        </line>
        <line x1="156" y1="110" x2="156" y2="110">
          <animate attributeName="y1" values="96;124;96" dur="0.9s" repeatCount="indefinite" />
          <animate attributeName="y2" values="124;96;124" dur="0.9s" repeatCount="indefinite" />
        </line>
        <line x1="168" y1="110" x2="168" y2="110">
          <animate attributeName="y1" values="88;132;88" dur="1.3s" repeatCount="indefinite" />
          <animate attributeName="y2" values="132;88;132" dur="1.3s" repeatCount="indefinite" />
        </line>
        <line x1="180" y1="110" x2="180" y2="110">
          <animate attributeName="y1" values="102;118;102" dur="1.05s" repeatCount="indefinite" />
          <animate attributeName="y2" values="118;102;118" dur="1.05s" repeatCount="indefinite" />
        </line>
      </g>

      <!-- report card -->
      <g transform="translate(204 60)">
        <rect width="92" height="100" rx="14" fill="rgb(var(--surface))" stroke="rgb(var(--border))" />
        <rect x="14" y="14" width="42" height="6" rx="3" fill="rgb(var(--text))" opacity="0.8" />
        <rect x="14" y="26" width="28" height="5" rx="2.5" fill="rgb(var(--text-muted))" opacity="0.5" />
        <!-- bars -->
        <g transform="translate(14 80)">
          <rect x="0"  y="-20" width="10" height="20" rx="3" fill="url(#wg-calls-bar)" />
          <rect x="16" y="-34" width="10" height="34" rx="3" fill="url(#wg-calls-bar)" />
          <rect x="32" y="-26" width="10" height="26" rx="3" fill="url(#wg-calls-bar)" />
          <rect x="48" y="-40" width="10" height="40" rx="3" fill="url(#wg-calls-bar)" />
          <rect x="64" y="-30" width="10" height="30" rx="3" fill="url(#wg-calls-bar)" />
        </g>
      </g>
    </svg>
  </div>
</template>
